const formatTwoDigits = (number, modifier = 0) => {
	if (number == null || Number.isNaN(number)) {
		return null;
	}

	const modded = String(number + modifier);
	return modded.length < 2 ? `0${modded}` : modded;
};

export default formatTwoDigits;
